import { CommonUtilities } from "../../commonUtils";
import React, { Suspense, useState, useEffect } from "react";
import contractServices from "./contractServices";
import ContractSummary from "./ContractSummary";
import TooltipList from "../Common/tooltip";
import cachingMechanisum from "../Common/cachingMechanisum";
import Pagination from "components/Common/newPagination";

export default function ContractListing(contractSearch: any) {

    const [totalRows, setTotalRows] = useState(1);
    var dataLink = "pageSize=10&pageNumber=1";
    const [contractslist, initContractslist] = useState<any[]>([]);
    const [contractRefNum, setContractRefNum] = useState<any[]>([]);
    const [selectConract, setSelectedContracts] = useState<any[]>([]);
    const [ContractStatus, setContractStatus] = useState<any[]>([]);
    const [ContractStatusKey, setContractStatusKey] = useState<any[]>([]);
    const [loop, setLoop] = useState(0);

    useEffect(() => {
        // getContract();
        var lookUpTypeList = cachingMechanisum.getCachingStorage("lookUpType");
        if (loop < 1) {
            for (var $i = 0; $i < lookUpTypeList?.length; $i++) {
                if (lookUpTypeList[$i].lookUpType === "ContractStatus") {
                    ContractStatus.push(lookUpTypeList[$i].value);
                    ContractStatusKey.push(lookUpTypeList[$i].key);
                }
            }
            setLoop(loop + 1);
        }

    }, []);


    var search_For = contractSearch.search;

    useEffect(() => {
        Data.searchFor = search_For;
        getContract()
    }, [search_For]);

    const pID: any = [contractSearch.contractSearch.ProjectId];
    const Data: any = {

        ProjectId: pID,
        export: 0,
        additionalInfo: "projectContractsStatus"
        //searchFor : ""

    }
    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        dataLink = 'pageSize=' + Data.pageSize + '&pageNumber=' + Data.pageNumber;
        getContract()
    }

    const getContract = () => {
        Data.ProjectId = contractSearch.contractSearch.ProjectId;

        contractServices.ContractListing(Data)
            .then((res) => {

                CommonUtilities.relativeDataRemapping(res.data, res.headers.original);
                setTotalRows(res.totalRows)
                contractSearch.onChange(res.totalRows)
                initContractslist(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
            })
    }

    const handleContract = (e: any) => {
        // console.log(e)
        setContractRefNum(e)

    }

    const onchangeContract = (e: any) => {
        //console.log(e)
        setSelectedContracts(e)
    }

    const changeStatus = (e: any, opt: any) => {

        var data = {
            "contractRefNum": e.contractRefNum,
            "contractTitle": e.contractTitle,
            "contractType": e.contractType,
            "contractStatusName": e.contractStatusName,
            "contractStatus": e.contractStatus,

            "accountStatus": e.accountStatus,
            "accountStatusName": e.accountStatusName,
            "accountStatusExt": e.accountStatusExt,
            "accountStatusExtName": e.accountStatusExtName,
            "statementCategory": e.statementCategory,
            "statementStatusName": e.statementStatusName,
            "contractAccountCode": e.contractAccountCode,
            "contractAccount": e.contractAccount,
            "mainEmail": e.mainEmail,
            "payeeStatus": e.payeeStatus,
            "payeeStatusName": e.payeeStatusName,
            "projectCode": e.projectCode,

        }

        if (opt === "prev") {

            for (var $i = 0; $i < ContractStatus.length; $i++) {
                if (ContractStatus[$i] === e.contractStatusName && (ContractStatus[$i - 1] !== null)) {
                    data.contractStatusName = ContractStatus[$i - 1];
                    data.contractStatus = ContractStatusKey[$i - 1];

                    contractServices.updateContractStatus(data)
                        .then((res) => {
                            if (res === true) {
                                getContract()
                            }
                        })

                }
            }

        } else if (opt === "next") {

            for (var $i = 0; $i < ContractStatus.length; $i++) {

                if ((ContractStatus[$i] === e.contractStatusName) && (ContractStatus[$i + 1] !== null)) {
                    data.contractStatusName = ContractStatus[$i + 1];
                    data.contractStatus = ContractStatusKey[$i + 1];

                    contractServices.updateContractStatus(data)
                        .then((res) => {
                            if (res === true) {
                                getContract()
                            }
                        })

                }
            }
        }

    }

    const downloadNewReports = (reportType: any, contractRefNum: any, contactCode: any, periodNum: any, format: any) => {
        var dataLink = '';

        if (contractRefNum) {
            dataLink = reportType + '?contractRefNum=' + contractRefNum + '&periodNum=' + periodNum + '&format=' + format;
        }
        else if (contactCode) {
            dataLink = reportType + '?contactCode=' + contactCode + '&periodNum=' + periodNum + '&format=' + format;
        }
        console.log(dataLink)

        contractServices.downloadNewReport(dataLink, reportType);
    }

    return (

        <div className="box-content p0">

            <Suspense fallback={<div>Loading</div>}>

                {
                    (() => {
                        if (totalRows && totalRows > 0) {
                            return (
                                <div className="allowHscroll">
                                    <table className="newTable">
                                        <thead>
                                            <tr className="forceSingleLine">
                                                <th>Contract code</th>
                                                <th> Contract Title</th>
                                                <th> Contract A/c codes</th>
                                                <th>Main Email</th>
                                                <th>Payee Status</th>
                                                <th>Payee Status Name</th>
                                                <th>Project Code</th>
                                                <th>Type</th>
                                                <th>Status</th>
                                                <th>A/C Status Name</th>
                                                <th>A/C Status Ext Name</th>
                                                <th>Category</th>
                                                <th>Statement Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                contractslist.map(post => (

                                                    <tr>
                                                        <td className="forceSingleLine">

                                                        </td>

                                                        <td className="forceSingleLine">
                                                        </td>

                                                        <td>{post.contractAccountCode} </td>
                                                        <td>{post.mainEmail} </td>
                                                        <td>{post.payeeStatus} </td>
                                                        <td>{post.payeeStatusName} </td>
                                                        <td>{post.projectCode} </td>
                                                        <td>{post.contractType} </td>
                                                        <td className="hide">
                                                            {post.contractAccount}
                                                            <div className={post.reportName !== "" ? 'pull-right ws-2' : ' hide'}>
                                                                <button className="icon-btn delete ms btn-sm hide">
                                                                    <i className="icon-file-pdf-o"></i>
                                                                </button>

                                                            </div>
                                                        </td>

                                                        <td>

                                                            <a className={post.contractStatusName !== null ? "btn-xs text-center ws-12 displayFlex" : "hide"}
                                                                style={{
                                                                    backgroundColor: CommonUtilities.lookUpTypeList('contractStatusName', post.contractStatusName, 'bgColor'),
                                                                    color: CommonUtilities.lookUpTypeList('contractStatusName', post.contractStatusName, 'fontColor')
                                                                }}>

                                                                <i className="icon-circle-left p0 m0 mtss text-center"
                                                                    style={{ color: CommonUtilities.lookUpTypeList('contractStatusName', post.contractStatusName, 'fontColor') }}
                                                                    onClick={() => { changeStatus(post, "prev") }} />

                                                                <span style={{ color: CommonUtilities.lookUpTypeList('contractStatusName', post.contractStatusName, 'fontColor') }}
                                                                    className="text-center ws-11">
                                                                    {post.contractStatusName}</span>

                                                                <i className="icon-circle-right p0 m0 mtss pull-right"
                                                                    style={{ color: CommonUtilities.lookUpTypeList('contractStatusName', post.contractStatusName, 'fontColor') }}
                                                                    onClick={() => { changeStatus(post, "next") }} />
                                                            </a>
                                                        </td>

                                                        <td>
                                                            <a className={post.accountStatusName !== "" ? "btn-xs text-center ws-12 displayFlex" : "hide"}
                                                                style={{
                                                                    backgroundColor: CommonUtilities.lookUpTypeList('accountStatusName', post.accountStatusName, 'bgColor'),
                                                                    color: CommonUtilities.lookUpTypeList('accountStatusName', post.accountStatusName, 'fontColor')
                                                                }}>

                                                                <span className="text-center ws-12"
                                                                    style={{ color: CommonUtilities.lookUpTypeList('accountStatusName', post.accountStatusName, 'fontColor') }}>
                                                                    {post.accountStatusName} </span>
                                                            </a>

                                                        </td>

                                                        <td>
                                                            <a className={post.accountStatusExtName !== "" ? "btn-xs text-center ws-12 displayFlex" : "hide"}
                                                                style={{
                                                                    backgroundColor: CommonUtilities.lookUpTypeList('accountStatusExtName', post.accountStatusExtName, 'bgColor'),
                                                                    color: CommonUtilities.lookUpTypeList('accountStatusExtName', post.accountStatusExtName, 'fontColor')
                                                                }}>

                                                                <span className="text-center ws-12"
                                                                    style={{ color: CommonUtilities.lookUpTypeList('accountStatusExtName', post.accountStatusExtName, 'fontColor') }}>
                                                                    {post.accountStatusExtName} </span>
                                                            </a>

                                                        </td>

                                                        <td>{post.statementCategory} </td>

                                                        <td>
                                                            <a className={post.statementStatusName !== "" ? "btn-xs text-center ws-12 displayFlex" : "hide"}
                                                                style={{
                                                                    backgroundColor: CommonUtilities.lookUpTypeList('statementStatusName', post.statementStatusName, 'bgColor'),
                                                                    color: CommonUtilities.lookUpTypeList('statementStatusName', post.statementStatusName, 'fontColor')
                                                                }}>

                                                                <span className="text-center ws-12"
                                                                    style={{ color: CommonUtilities.lookUpTypeList('statementStatusName', post.statementStatusName, 'fontColor') }}>
                                                                    {post.statementStatusName} </span>
                                                            </a>

                                                        </td>


                                                        <td className="hide">
                                                            <div className={post.mainReport ? "ws-12 " : "hide"}>
                                                                <TooltipList text={"Statement " + post.mainReport + " PDF"}>
                                                                    <button className="icon-btn delete ms btn-sm" onClick={() => { downloadNewReports('detail', post.contractRefNum, '', '20191231', 'pdf') }}>
                                                                        <i className="icon-file-pdf-o"></i>
                                                                    </button>
                                                                </TooltipList>

                                                                <TooltipList text={"Statement " + post.mainReport + " Excel"}>
                                                                    <button className="icon-btn edit ms btn-sm" onClick={() => { downloadNewReports('detail', post.contractRefNum, '', '20191231', 'excel') }}>
                                                                        <i className="icon-file-excel-o"></i>
                                                                    </button>
                                                                </TooltipList>

                                                            </div>

                                                        </td>
                                                    </tr>

                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            )
                        } else {
                            return (<div className="ptl">
                                <span className="alert alert-success ws-12 text-center">No data Available</span>
                            </div>)
                        }

                    })()
                }



                <div className="ws-12 ptl">
                    {
                        (() => {
                            if (totalRows && totalRows > 10) {
                                return <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />
                            }

                        })()
                    }

                </div>
            </Suspense>
        </div>

    )
}